import React from 'react'
import type { SimpleUser } from '../providers/context'
import { useAppContext } from '../providers/context'
import { Avatar } from './avatar'
import { SmartLinkOptional } from './simple/link'

/**
 * UserCard component that displays a user's avatar, name, role, and location.
 * It can also be a link to the user's profile.
 * @param user - The user object containing user information.
 * @param linkTo - Optional link to navigate to when the card is clicked.
 * @param className - Additional classes for styling.
 */
export const UserCard: React.FC<{
  user: SimpleUser
  linkTo?: string
  className?: string
}> = ({ user, linkTo, className }) => {
  const { state } = useAppContext()
  return (
    <SmartLinkOptional to={linkTo} className={`flex ${className}`}>
      <Avatar {...(state.user == user && { self: true })} src={user.avatar} className="my-1" />
      <div className="ml-3 flex min-w-0 flex-col justify-center">
        <span className="-mb-1 overflow-hidden text-ellipsis text-nowrap font-semibold">{user.name}</span>
        <span className="max-w-72 overflow-hidden text-ellipsis text-nowrap text-sm text-gray-500">
          {user.role} | {user.location}
        </span>
      </div>
    </SmartLinkOptional>
  )
}
